import { useMutation, useQueryClient } from "@tanstack/react-query";

import { userPushPreferencesQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  PushType,
  UpdateUserPushPreferenceRequest,
  UserPushPreferenceResponse,
} from "@/types";

export const useUpdateSetUserPushPreference = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      type,
      ...request
    }: { type: PushType } & UpdateUserPushPreferenceRequest) => {
      const path = `user-push-preferences/${type}`;
      const res = await guacHttpClient.patch<
        UserPushPreferenceResponse,
        HttpResponse<UserPushPreferenceResponse>,
        UpdateUserPushPreferenceRequest
      >(path, request);
      return res.data;
    },
    onSuccess: (updatedPreference) => {
      queryClient.setQueryData<UserPushPreferenceResponse[]>(
        userPushPreferencesQueryKey,
        (cachedData) =>
          cachedData?.map((preference) =>
            preference.type === updatedPreference.type
              ? updatedPreference
              : preference,
          ),
      );
    },
  });
};
